/**
 * PATH: packages/job-hub/src/jobs/qa/saveItpPdf.ts
 * FILE_ID: JOBHUB-QA-SAVE-ITP-PDF-001
 * PURPOSE: Save the same Print HTML as a PDF file.
 * LANDMINE: Do not call generateReport. That queues a Report row and a
 *   second layout. renderItpPdf returns the file and stores nothing.
 */
import type { QaApi } from './qaTypes'
import { writePdfToHandleOrDownload } from './downloadBlobFile'

export interface SaveItpPdfOptions {
  api: Pick<QaApi, 'renderItpPdf'>
  inspectionId: string
  html: string
  fileHandle?: FileSystemFileHandle | null
  filename?: string
}

export async function saveItpPdf({
  api,
  inspectionId,
  html,
  fileHandle,
  filename,
}: SaveItpPdfOptions): Promise<void> {
  const blob = await api.renderItpPdf(inspectionId, html)
  await writePdfToHandleOrDownload(blob, filename || 'inspection-plan.pdf', fileHandle ?? null)
}
